import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Input, Checkbox } from "formsy-react-components";
import { Row, Col } from "react-bootstrap";

import * as expenseActions from "../../actions/expenseActions";

import DropdownSearch from "../common/DropdownSearch";
import FileUpload from "../common/FileUpload";
import { customToast as toast } from "../../utils";
import ExpenseReceiptList from "./ExpenseReceiptList";

class ExpenseLineForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableAmount: false,
      amount: ""
    };
  }

  onChange = (field, selected) => {
    const { row } = this.props;
    const innerField = field.slice(0, -3);

    // use quantity and amount to calculate total
    if (innerField.includes("quantity")) {
      this.setState({ [innerField]: selected });

      if (this.state.amount) {
        this.setState({ total: (selected * this.state.amount).toFixed(2) });
      } else if (row.amount) {
        this.setState({ total: (selected * row.amount).toFixed(2) });
      }
    } else if (innerField.includes("amount")) {
      this.setState({ [innerField]: selected });
      if (this.state.quantity) {
        this.setState({ total: (selected * this.state.quantity).toFixed(2) });
      } else if (row.quantity) {
        this.setState({ total: (selected * row.quantity).toFixed(2) });
      }
    }
    // set category and mileage amount
    else if (innerField.includes("category")) {
      this.setState({ category: selected.value });
      if (innerField.includes("category") && selected.label === "Mileage") {
        this.setState({ amount: 0.3, disableAmount: true });
        if (this.state.quantity) {
          this.setState({ total: (0.3 * this.state.quantity).toFixed(2) });
        } else if (row.quantity) {
          this.setState({ total: (0.3 * row.quantity).toFixed(2) });
        }
      } else if (
        innerField.includes("category") &&
        selected.label !== "Mileage"
      ) {
        this.setState({ disableAmount: false });
      }
    }
    // other fields
    else {
      this.setState({ [innerField]: selected.value });
    }
  };

  onClickDeleteReceipt = () => {
    this.setState({ file: {} });
  };

  // upload reeipt to S3, then send to parent expenseForm
  uploadFile = async (file) => {
    try {
      const { fileName } = await this.props.actions.uploadFile(file);
      const fullPath = `https://gfs-redkeep.s3.amazonaws.com/Expenses/${fileName}`;

      const newFile = file[0];
      newFile.path = fullPath;
      newFile.id = this.props.id;

      this.setState({ file: newFile });
      this.props.uploadReceipt(newFile);
    } catch (err) {
      toast.error(err.message);
    }
  };

  render() {
    let {
      row,
      generateCodeOptions,
      editing,
      adding,
      id,
      codes,
      actions,
      expense,
      auth
    } = this.props;

    const receipt = this.state.file || this.props.file || {};
    const status = {
      submitted: codes?.find(
        (c) =>
          c.label === "Submitted" &&
          c.field === "status" &&
          c.entity === "Expenses"
      ),
      approved: codes?.find(
        (c) =>
          c.label === "Approved" &&
          c.field === "status" &&
          c.entity === "Expenses"
      ),
      completed: codes?.find(
        (c) =>
          c.label === "Completed" &&
          c.field === "status" &&
          c.entity === "Expenses"
      )
    };

    const onClickDownload = (file) => {
      actions.downloadFile(expense, file);
    };

    // set status
    let lineStatus;
    if (row.status === status?.submitted?.id) {
      lineStatus = false;
    } else if (
      row.status === status?.approved?.id ||
      row.status === status?.completed?.id
    ) {
      lineStatus = true;
    }

    // if editing existing expense, set to first element
    if (!adding) {
      id = 0;
    }

    return (
      <Row>
        <Col md={3} xs={12}>
          <DropdownSearch
            required
            name={`category[${id}]`}
            label="Category"
            onChange={this.onChange}
            value={this.state.category || row.category}
            data={[...generateCodeOptions("Expenses", "category")]}
            disabled={!editing}
          />
        </Col>
        <Col md={3} xs={12}>
          <Input
            required
            type="number"
            name={`quantity[${id}]`}
            label="Quantity"
            value={this.state.quantity || row.quantity}
            disabled={!editing}
            onChange={this.onChange}
            pattern="[0-9]*"
            step="0.01"
            inputMode="decimal"
          />
        </Col>
        <Col md={3} xs={12}>
          <Input
            required
            type="number"
            name={`amount[${id}]`}
            label="$ Unit Amount"
            disabled={!editing || this.state.disableAmount}
            value={this.state.amount || row.amount}
            onChange={this.onChange}
            pattern="[0-9]*"
            step="0.01"
            inputMode="decimal"
          />
        </Col>
        <Col md={3} xs={12}>
          <Input
            required
            type="number"
            name={`total[${id}]`}
            label="$ Total Amount"
            disabled
            value={this.state.total || row.total}
          />
        </Col>
        <Col md={12} xs={12}>
          <Input
            required
            name={`description[${id}]`}
            label="Expense Description"
            value={this.state.description || row.description}
            disabled={!editing}
            validations={{ maxLength: 250 }}
            validationErrors={{
              maxLength: "You can not type in more than 250 characters"
            }}
          />
        </Col>
        <Col md={adding ? 4 : 3} xs={12}>
          <Checkbox
            formNoValidate
            name={`bill_to_customer[${id}]`}
            valueLabel="Bill to Customer"
            value={row.bill_to_customer}
            disabled={!editing}
          />
        </Col>
        <Col md={adding ? 4 : 3} xs={12}>
          <Checkbox
            formNoValidate
            name={`reimburse_to_employee[${id}]`}
            valueLabel="Reimburse Employee"
            value={row.reimburse_to_employee}
            disabled={!editing}
          />
        </Col>
        <Col md={adding ? 4 : 3} xs={12}>
          <Checkbox
            formNoValidate
            name={`occurs_annually[${id}]`}
            valueLabel="Occurs Annually"
            value={row.occurs_annually}
            disabled={!editing}
          />
        </Col>
        {!adding && (
          <Col md={3} xs={12}>
            <Checkbox
              formNoValidate
              name="status"
              valueLabel="Approved"
              disabled
              value={lineStatus}
            />
          </Col>
        )}
        <Col xs={12}>
          {editing && !receipt.path && (
            <>
              <div
                style={{
                  paddingLeft: "15px",
                  color: "#b8bac5",
                  fontSize: "11px",
                  fontWeight: "bold"
                }}
              >
                UPLOAD RECEIPT
              </div>
              <FileUpload auth={auth} onDrop={this.uploadFile} />
              {this.state.file ? (
                <div style={{ marginLeft: "20px" }}>{this.state.file.name}</div>
              ) : null}
            </>
          )}
          {receipt.path && (
            <ExpenseReceiptList
              onClickDownload={onClickDownload}
              type="RECEIPTS:"
              receipts={[receipt]}
              onClickDelete={this.onClickDeleteReceipt}
              hideReceiptDelete={!editing}
            />
          )}
        </Col>
      </Row>
    );
  }
}

ExpenseLineForm.propTypes = {
  actions: PropTypes.object,
  adding: PropTypes.bool,
  editing: PropTypes.bool,
  row: PropTypes.object,
  uploadReceipt: PropTypes.func,
  generateCodeOptions: PropTypes.func,
  id: PropTypes.number,
  file: PropTypes.string,
  codes: PropTypes.array,
  expense: PropTypes.object
};

const mapStatesToProps = (state) => ({
  state: state.reducers,
  customers: state.reducers.customers,
  projects: state.reducers.projects,
  expenses: state.reducers.expenses,
  expenseReceiptToDelete: state.reducers.expenseReceiptToDelete
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...expenseActions
    },
    dispatch
  )
});

export default connect(mapStatesToProps, mapDispatchToProps)(ExpenseLineForm);
